var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgApplianceRepair = function SvgApplianceRepair(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 44,
    height: 50,
    viewBox: "0 0 22 25"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "a",
    d: "M0 0h20.161v25H0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "c",
    d: "M0 25h20.161V0H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(.92)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M19.355 4.032H.806v-2.62c0-.335.271-.605.605-.606H18.75c.334 0 .605.271.605.605zm0 19.557c0 .334-.271.604-.605.605H1.411a.605.605 0 0 1-.605-.605V4.839h18.549zM18.75 0H1.411C.632 0 .001.632 0 1.411V23.59c0 .779.632 1.41 1.411 1.411H18.75c.78 0 1.41-.632 1.411-1.411V1.41c0-.779-.632-1.41-1.411-1.411",
    mask: "url(#b)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M10.08 18.952a4.839 4.839 0 1 1 0-9.678 4.839 4.839 0 0 1 0 9.678m0-10.484a5.645 5.645 0 1 0 5.646 5.645 5.65 5.65 0 0 0-5.645-5.645",
    mask: "url(#b)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "d",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#c"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M2.016 2.823h.807v-.807h-.807zm-.403.806h1.613c.222 0 .403-.18.403-.403V1.613a.403.403 0 0 0-.403-.403H1.613a.403.403 0 0 0-.403.403v1.613c0 .222.18.403.403.403M4.839 2.823h.806v-.807H4.84zm-.404.806h1.613c.223 0 .404-.18.404-.403V1.613a.403.403 0 0 0-.404-.403H4.435a.403.403 0 0 0-.403.403v1.613c0 .222.18.403.403.403M7.661 2.823h.807v-.807H7.66zm-.403.806h1.613c.223 0 .403-.18.403-.403V1.613a.403.403 0 0 0-.403-.403H7.258a.403.403 0 0 0-.403.403v1.613c0 .222.18.403.403.403M18.145 15.524c0 .334-.27.605-.605.605h-.201v-4.032h.201c.334 0 .605.27.605.605zm-8.064 5.04a6.452 6.452 0 1 1 6.451-6.451 6.46 6.46 0 0 1-6.451 6.451m7.46-9.274h-.606a.4.4 0 0 0-.155.032 7.27 7.27 0 0 0-6.7-4.467c-4.001 0-7.257 3.256-7.257 7.258s3.256 7.258 7.258 7.258a7.27 7.27 0 0 0 6.7-4.467q.073.031.154.031h.605c.78 0 1.41-.632 1.412-1.41v-2.823c-.001-.78-.633-1.41-1.412-1.412",
    mask: "url(#d)"
  }))));
};
export default SvgApplianceRepair;